import { SafeUrl } from '@angular/platform-browser';

export interface IAttachment {
  title?: string;
  type: AttachmentTypes;
  description?: string;
  thumbnailURL: string | ArrayBuffer | SafeUrl;
  highResolutionURL?: string;
  lowResolutionURL?: string;
  uid?: string;
  file?: File;
  size?: number;
  error?: boolean;
  isCorrupted?: boolean;
}

export interface IImageType {
  name: string;
  type: string;
}

export enum AttachmentTypes {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
}

export enum WebAppAttachmentTypes {
  JPEG = 'JPEG',
  PDF = 'PDF',
  XML = 'XML',
  PNG = 'PNG',
  MP4 = 'MP4',
  GIF = 'GIF',
  QUICKTIME = 'QUICKTIME',
  _3GPP = '_3GPP',
  VCARD = 'VCARD',
  BMP = 'BMP',
  AMR = 'AMR',
  MP4_AUDIO = 'MP4_AUDIO',
  MPEG = 'MPEG',
  WAV = 'WAV',
  OGG = 'OGG',
}

export const WebappAttachmentConverter = {
  JPEG: AttachmentTypes.IMAGE,
  PDF: AttachmentTypes.DOCUMENT,
  XML: AttachmentTypes.DOCUMENT,
  PNG: AttachmentTypes.IMAGE,
  MP4: AttachmentTypes.VIDEO,
  GIF: AttachmentTypes.IMAGE,
  QUICKTIME: AttachmentTypes.VIDEO,
  _3GPP: AttachmentTypes.VIDEO,
  VCARD: AttachmentTypes.DOCUMENT,
  BMP: AttachmentTypes.IMAGE,
  AMR: AttachmentTypes.AUDIO,
  MP4_AUDIO: AttachmentTypes.AUDIO,
  MPEG: AttachmentTypes.VIDEO,
  WAV: AttachmentTypes.AUDIO,
  OGG: AttachmentTypes.AUDIO,
};
